module.exports = __webpack_public_path__ + "static/media/ticket-icon.e92de05e.svg";